import React from 'react';
import PropTypes from 'prop-types';

const NameMatch = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6673 4.66602H9.33398V6.99935H5.83398C4.90573 6.99935 4.01549 7.3681 3.35911 8.02448C2.70273 8.68085 2.33398 9.57109 2.33398 10.4993V17.4993C2.33398 18.4276 2.70273 19.3178 3.35911 19.9742C4.01549 20.6306 4.90573 20.9993 5.83398 20.9993H9.33398V23.3327H11.6673V4.66602ZM9.33398 9.33268V18.666H5.83398C5.52456 18.666 5.22782 18.5431 5.00903 18.3243C4.79023 18.1055 4.66732 17.8088 4.66732 17.4993V10.4993C4.66732 10.1899 4.79023 9.89318 5.00903 9.67439C5.22782 9.4556 5.52456 9.33268 5.83398 9.33268H9.33398Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M22.1676 18.6657H14.001V20.999H22.1676C23.0959 20.999 23.9861 20.6303 24.6425 19.9739C25.2989 19.3175 25.6676 18.4273 25.6676 17.499V10.499C25.6676 9.57077 25.2989 8.68053 24.6425 8.02415C23.9861 7.36777 23.0959 6.99902 22.1676 6.99902H14.001V9.33236H22.1676C22.4771 9.33236 22.7738 9.45527 22.9926 9.67407C23.2114 9.89286 23.3343 10.1896 23.3343 10.499V17.499C23.3343 17.8084 23.2114 18.1052 22.9926 18.324C22.7738 18.5428 22.4771 18.6657 22.1676 18.6657Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

NameMatch.propTypes = {
  fill: PropTypes.string,
};

export default NameMatch;
